module.exports = __webpack_public_path__ + "static/media/icon_price.108a099c.svg";